 <script setup>
import {onMounted, provide, ref} from "vue";

    const props = defineProps({
        lead: {
            type: Object,
            required: true
        }
    })

    const emit = defineEmits(['update:lead', 'archived', 'deleted'])
    const _lead = ref(null)

    const loadLead = async () => {
        const res = await axios.get(route('api.crm.lead.show', props.lead.id))

        _lead.value = res.data.lead
    }

    const updateLead = async (incomingLead) => {
        emit('update:lead', incomingLead)
    }

    onMounted(() => {
        loadLead()
    })

    provide('lead', _lead)
</script>

<template>
  <div>
      <div
          v-if="_lead"
          class="pb-24"
      >
<!--          <tags-manage-inline-->
<!--              ref="tagsManage"-->
<!--              :lead-id="_lead.id"-->
<!--              container="card-default"-->
<!--              class="mb-4"-->
<!--          ></tags-manage-inline>-->
<!--          -->
<!--          <lead-details-->
<!--              :lead-id="_lead.id"-->
<!--              @update:lead="updateLead"-->
<!--              @reload:lead="loadLead"-->
<!--              :allow-delete="true"-->
<!--              :allow-archive="true"-->
<!--              :redirect-after-delete="false"-->
<!--              @archived="emit('archived')"-->
<!--              @deleted="emit('deleted')"-->
<!--          />-->

          <page-crm-leads-single
              :lead-id="_lead.id"
              :as-widget="true"
              @update:lead="updateLead"
              @archived="emit('archived')"
              @deleted="emit('deleted')"
          ></page-crm-leads-single>
      </div>
      <mf-spinner-medium
          v-else
          class="w-24 h-12"
      />
  </div>
</template>

<style scoped>

</style>
